import AccessControl from '@modules/auth/AccessControl'
import BooleanCell from '@modules/tableComponents/Cell.Boolean'
import EmptyTable from '@modules/tableComponents/Table.Empty'
import moment from 'moment'
import React, { Component } from 'react'
import Checkbox from 'react-bootstrap/es/Checkbox'
import DropdownButton from 'react-bootstrap/es/DropdownButton'
import MenuItem from 'react-bootstrap/es/MenuItem'
import { Trans, withTranslation } from 'react-i18next'
import { Link } from 'react-router-dom'
import Consultations from '@services/Consultations'
import { ProfessionalStatus } from '../../tableComponents/Cell.ProfessionalAndStatus'

export class RoomTable extends Component {
  state = {
    selectedRooms: [],
  }

  toggleRow = (id) => {
    if (this.state.selectedRooms.includes(id)) {
      this.setState({ selectedRooms: this.state.selectedRooms.filter((el) => el !== Number(id)) })
    } else {
      this.setState({ selectedRooms: [...this.state.selectedRooms, id] })
    }
  }

  toggleRowCheckbox = (e) => {
    if (e.target.checked) {
      this.setState({ selectedRooms: [...this.state.selectedRooms, Number(e.target.id)] })
    } else {
      this.setState({ selectedRooms: this.state.selectedRooms.filter((el) => el !== Number(e.target.id)) })
    }
  }

  toggleAll = (e) => {
    if (e.target.checked) {
      this.setState({ selectedRooms: this.props.items.map((item) => item.id) })
    } else {
      this.setState({ selectedRooms: [] })
    }
  }

  handleActivateRooms = () => {
    Consultations.adminRooms
      .bulkActivate(this.state.selectedRooms)
      .then(this.props.onRoomUpdateSuccess)
      .catch((e) => console.error(e))
  }

  handleDeactivateRooms = () => {
    Consultations.adminRooms
      .bulkDeactivate(this.state.selectedRooms)
      .then(this.props.onRoomUpdateSuccess)
      .catch((e) => console.error(e))
  }

  render() {
    const { items, t } = this.props
    if (!items) return 'ERROR'
    if (items.length === 0) return <EmptyTable />

    return (
      <div style={{ paddingTop: '10px' }}>
        <AccessControl requiredRole="superAdmin">
          <div style={{ float: 'right', marginRight: 12 }}>
            <DropdownButton bsStyle={'primary'} title={t('Acciones')} id={'roomsIndex'}>
              <MenuItem eventKey="activate" onSelect={this.handleActivateRooms}>
                <Trans>Activar</Trans>
              </MenuItem>
              <MenuItem eventKey="deactivate" onSelect={this.handleDeactivateRooms}>
                <Trans>Desactivar</Trans>
              </MenuItem>
            </DropdownButton>
          </div>
        </AccessControl>

        <table className="md-table">
          <thead>
            <tr>
              <th style={{ width: 60 }}>
                <Checkbox onChange={this.toggleAll} />
              </th>
              <th>
                <Trans>Chat</Trans>
              </th>
              <th>
                <Trans>Primer mensaje</Trans>
              </th>
              <th>
                <Trans>Último mensaje</Trans>
              </th>
              <th>
                <Trans>Profesional</Trans>
              </th>
              <th>
                <Trans>Respuesta</Trans>
              </th>
              <th>
                <Trans>Activa</Trans>
              </th>
              <th>
                <Trans>Valoración</Trans>
              </th>
              <th>
                <Trans>Revisión</Trans>
              </th>
            </tr>
          </thead>
          <tbody>
            {items.map((room) => (
              <tr key={room.id} onClick={() => this.toggleRow(room.id)}>
                <td style={{ textAlign: 'center' }}>
                  <Checkbox checked={this.state.selectedRooms.includes(room.id)} onChange={this.toggleRowCheckbox} />
                </td>
                <td>
                  {!!room.customer.vip && <i style={{ color: '#ffa900', paddingRight: 6 }} className="far fa-star" />}
                  {room.is_viewable ? <Link to={`/room/${room.id}`}>{room.id}</Link> : '--'}
                </td>
                <td style={{ whiteSpace: 'normal' }}>
                  {moment(room.first_message_at).format('L')} <br /> {moment(room.first_message_at).fromNow()}
                </td>
                <td style={{ whiteSpace: 'normal' }}>
                  {moment(room.last_message_at).format('L')} <br /> {moment(room.last_message_at).fromNow()}
                </td>

                <td>
                  <ProfessionalStatus status={room.professional.status} /> {room.professional.name}
                </td>
                <td>
                  <BooleanCell value={!room.need_to_answer} />
                </td>
                <td>
                  <BooleanCell value={room.is_active} />
                </td>

                <td>{(room.last_survey && room.last_survey.satisfaction) || '-'}</td>
                <td>{(room.last_review && room.last_review.review) || '-'}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    )
  }
}

export default withTranslation()(RoomTable)
